const styles = theme => ({
  root: {
    height: '100%',
    width: '100%',
    '.dialog-title': {
      display: 'flex',
      'flex-direction': 'row',
      '-ms-flex-direction': 'row',
    },
    flex: 1,
    button: { bottom: 0, position: 'absolute' },
    // backgroundColor: theme.palette.background.paper,
    backgroundColor: '#f4f6fa !important',
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/containers/meals/mobile/mealsSelection/MealsSelectionDialogStyles.js